import { Injectable } from '@angular/core';
import { ITableData } from '../../models/ITableData';
import * as Papa from 'papaparse';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CSVService {

  /**
   * Creates a sample csv with just the column the headers and prompts to download
   * @param anchor The <a> html element that serves as download button
   * @param filename The generated csv filename
   * @param cols Array with fields to use as headers
   */
  static exportCSV(anchor: HTMLAnchorElement, filename: string, cols: string[]): void;

  /**
   * Creates a sample csv with the suplied sample data and prompts to download
   * @param anchor The <a> html element that serves as download button
   * @param filename The generated csv filename
   * @param data Array with sample data as objects
   */
  static exportCSV(anchor: HTMLAnchorElement, filename: string, sample: {[header: string]: (string | number | boolean)}[]): void;


  static exportCSV(anchor: HTMLAnchorElement, filename: string, data: any[]) {
    if (typeof (data[0]) == typeof ('string')) {
      data = [data];
    }
    const csv = Papa.unparse(data);    

    // taken from this StackOverflow answer:
    // https://stackoverflow.com/questions/16078544/export-to-csv-using-jquery-and-html/16203218#16203218
    anchor.setAttribute('download', filename);

    if (window.Blob && window.URL) {
      // HTML5 Blob
      var blob = new Blob([csv], {
        type: 'text/csv;charset=utf-8'
      });
      var csvUrl = URL.createObjectURL(blob);
      
      anchor.setAttribute('href', csvUrl);
    } else {
      // Data URI
      var csvData = 'data:application/csv;charset=utf-8,' + encodeURIComponent(csv);

      anchor.setAttribute('href', csvData);
      anchor.setAttribute('target', '_blank');
    }
  }

  
  /**
   * Parse a csv string and return an array of objects, taking the header row as keys
   * @param file CSV string to parse
   */
   //static parseCSV(file: string): Observable<any[]>;

  /**
   * Parse a csv file and return an array of objects, taking the header row as keys
   * @param file CSV File to parse
   */
  static parseCSV(file: File): Observable<any[]>;

  /**
   * Parse a csv file and return an array of objects, taking the header row as keys
   * If step is present it emmits row by row, use for large files
   * @param file CSV File to parse
   * @param step Whether to parse whole file or row by row
   */
  static parseCSV(file: File, step: boolean): Observable<any>;

  static parseCSV(file: File, step?: boolean) {
    Papa.parse(file);
    
    return new Observable(suscriber => {
      let options = {
        header: false,
        skipEmptyLines: true,
        error: suscriber.error,
      }
      if (step != undefined) {
        Papa.parse(file, {
          ...options,
          worker: true,
          step: row => suscriber.next(row.data),
          complete: _ => suscriber.complete()
        })
      } else {
        Papa.parse(file, {
          ...options,
          complete: contents => {
            suscriber.next(contents.data);
            suscriber.complete();
          }
        });
      }
    })
  }

  /**
   * Transform papaparse data to key value pairs
   * @param data The data to transform. First row are the keys and the rest are the rows
   * @returns The transformed data
   */
   static transformData(data: any[]): ITableData[] {
    const keys = data[0];
    const rows = data.slice(1);
    // map over the rows
    const array = rows.map((row: any) => {
      // map over the columns
      return row.reduce((acc: any, column: any, i: number) => {
        // create an object with the key and value
        acc[keys[i]] = column;
        return acc;
      }, {});
    });
    return array;
  }
}
